window.addEventListener('DOMContentLoaded', () => {
    let agreements = document.querySelector('.agreements');
    let checkbox = agreements.querySelector('input[name="agreementAll"]');
    let checkboxes = agreements.querySelectorAll('.checkbox__input');

    agreements.querySelector('.agreements__bar').addEventListener('click', () => {
        if (agreements.classList.contains('agreements--collapsed')) {
            agreements.classList.remove('agreements--collapsed');
        } else {
            agreements.classList.add('agreements--collapsed');
        }
    });

    checkbox.addEventListener('click', () => {
        if (checkbox.checked) {
            checkboxes.forEach((input) => {
                input.checked = true;
                input.dispatchEvent(new Event('change'));
            });
        } else {
            checkboxes.forEach((input) => {
                input.checked = false;
                input.dispatchEvent(new Event('change'));
            });
        }
    });
});